import { Pane, Link, Text, ArrowTopRightIcon } from "evergreen-ui";
import { theme } from "../../../theme";

export const Links = () => {
  const Href = ({ href, text, target }) => {
    return (
      <Link width="fit-content" href={href} target={target}>
        <Pane display="flex" flexDirection="row" alignItems="center" gap={5}>
          <Text color={theme.colors.green}>{text}</Text>
          <ArrowTopRightIcon color="#5C85FF" size={10} />
        </Pane>
      </Link>
    );
  };

  return (
    <Pane display="flex" flexDirection="column" gap={10}>
      <Href href="https://cafeqr.ca" text="CafeQR (App)" target="_blank" />
    </Pane>
  );
};
